'use strict';

export default class ScheduleFormController {
  errors = {
    saveSchedule: undefined,
    other: undefined
  };
  message = '';
  submitted = false;

  year = new Date().getFullYear();
  yearsToList = 2;
  years = [];

  /*@ngInject*/
  constructor(Upload, Schedules, schedule, $state) {
    this._$state = $state;
    this._Schedules = Schedules;
    this.$Uploader = Upload;

    this.loading = false;

    // timeDate to set date the same for all times
    this.timeDate = '2001-01-01';

    this.mission = null;

    this.printableData = null;
    for(var i = 0; i <= this.yearsToList; i++) {
      this.years.push(this.year + i);
    }
    this.years.push(this.year - 1);
    this.setTimes();
    this.setSpecial();
    console.log('Schedule');
    console.log(schedule);
    if(!schedule) {
      this.setSchedule();
    } else {
      this.schedule = schedule;
      this.schedule.startDate = new Date(this.schedule.startDate);
      this.schedule.endDate = new Date(this.schedule.endDate);
      if(this.schedule.publishDate) {
        this.schedule.publishDate = new Date(this.schedule.publishDate);
      }
    }
    this.setDays();

    this.today = new Date();

    // Key for days (numerical) to string 0 => Sunday, etc.
    this.dayKey = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'No Service', 'Special', 'Election Day'];

    if(this._$state.current.name == 'schedule.edit') {
      this.mission = 'edit';
      this.pageTitle = `Edit ${this.schedule.location} ${this.schedule.season} Schedule`;
    } else {
      this.mission = 'new';
      this.pageTitle = 'Create New Schedule';
    }
  }

  setTimes() {
    this.time = {
      departing: 'BS',
      peak: false,
      lateNight: false,
      setTime: new Date('2001-01-01 07:00:00'),
      gate: '',
      exceptions: {
        startDate: null,
        endDate: null,
        exceptDate: [],
        onlyDate: [],
        dailyStarts: null,
        dailyEnds: null,
        andThen: false,
      },
      note: null
    };
  }

  setSpecial() {
    this.special = {
      departing: 'BS',
      peak: false,
      lateNight: false,
      setTime: new Date('2001-01-01 07:00:00'),
      note: null
    };
  }

  deletePrintSchedule() {
    this.schedule.printable = null;
  }

  // Upload Printable Schedule
  upload(file) {
    // Set boolean for spinner to enable/disable
    this.uploading = false;
    console.log(file);

    // Use ng-file-upload to upload to express route
    this.$Uploader.upload({
      url: '/api/schedules/upload',
      fields: {
        test: 'thisisatest'
      },
      file
    }).progress(evt => {
      // Show spinner while uploading/waiting for response
      this.uploading = true;

      // Calculate progress
      // Doesn't work considering AWS upload
      let progressPercentage = parseInt(100.0 * evt.loaded / evt.total, 10);
      this.percentageLoaded = progressPercentage;
      console.log(`progress: ${progressPercentage}% ${evt.config.file.name}`);
    })
    .success(data => {
      // Upon success, add link and file data to schedule
      this.schedule.printable = data;
      // Turn off spinner
      this.uploading = false;
      console.log(data);
    });
  }

  setDays() {
    this.days = [false, false, false, false, false, false, false];
  }

  checkTimes() {
    console.log(this.days.indexOf(true));
    if(this.days.indexOf(true) > -1) {
      return true;
    }
    return false;
  }

  setSchedule() {
    this.schedule = {
      year: this.year.toString(),
      times: [],
      notes: {
        legend: [],
        above: [],
        below: []
      },
      holidays: [],
      special: [],
      format: 'Four Panel'
    };
  }

  checkDays(mode) {
    if(mode == 'm-th') {
      this.setDays();
      this.days[1] = true;
      this.days[2] = true;
      this.days[3] = true;
      this.days[4] = true;
    } else if(mode == 's-su') {
      this.setDays();
      this.days[0] = true;
      this.days[6] = true;
    } else if(mode == 'clear') {
      this.setDays();
    }
  }

  addNote() {
    let noteData = this.note;
    this.schedule.notes[noteData.location].push(noteData);
    this.note = {};
  }

  addHoliday() {
    let holidayData = this.holiday;
    holidayData.dayOf = holidayData.date.getDay();
    if(holidayData.actAs) {
      holidayData.actAs = this.dayKey.indexOf(holidayData.actAs);
    }
    this.schedule.holidays.push(holidayData);
    this.holiday = {};
  }

  setElectionDay() {
    this.schedule.electionSchedule = {
      date: this.electionDay,
      trips: [],
    };
  }

  addElectionTrip() {
    this.schedule.electionSchedule.trips.push({
      from: this.electionTrip.from,
      to: this.electionTrip.to,
      note: this.electionTrip.note,
      time: this.convertTime(this.electionTrip.setTime),
    });
  }

  removeElectionDay() {
    this.schedule.electionSchedule = null;
  }

  zeroPad(num, places) {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join('0') + num;
  }

  checkHolidays(type, holidays) {
    if(holidays && holidays.length) {
      for(let index = 0; index < holidays.length; index++) {
        console.log('holiday: ', holidays[index].actAs);
        if(holidays[index].actAs === type) {
          return true;
        }
      }
    }
    return false;
  }

  addSpecial() {

    let timeData = {
      time: this.convertTime(this.special.setTime),
      peak: this.special.peak,
      departing: this.special.departing,
      lateNight: this.special.lateNight,
      note: this.special.note,
    };

    this.schedule.special.push(timeData);
  }

  // Convert Time to String Format i.e 15:10:00
  convertTime(time) {
    let hours = time.getHours();
    let minutes = time.getMinutes();
    return `${this.zeroPad(hours, 2)}:${this.zeroPad(minutes, 2)}:00`;
  }

  addTime() {
    if(!this.checkTimes()) {
      return;
    }
    let days = [];

    console.log(this.days);

    for(let i = 0; i < this.days.length; i++) {
      if(this.days[i]) {
        days.push(i);
      }
    }

    console.log(days);

    console.log('AndTHen:', this.time.exceptions.andThen);

    let timeData = {
      time: this.convertTime(this.time.setTime),
      note: this.time.note,
      days,
      departing: this.time.departing,
      startDate: this.time.exceptions.startDate,
      endDate: this.time.exceptions.endDate,
      dailyStarts: this.time.exceptions.dailyStarts,
      dailyEnds: this.time.exceptions.dailyEnds,
      andThen: this.time.exceptions.andThen,
      peak: this.time.peak,
      gate: this.time.gate,
      lateNight: this.time.lateNight
    };

    // if(this.time.exceptions.onlyDate) {
    //   timeData.onlyDate = [this.time.exceptions.onlyDate];
    //   if(this.time.exceptions.onlyDate2) {
    //     timeData.onlyDate.push(this.time.exceptions.onlyDate2);
    //   }
    // }
    //
    // if(this.time.exceptions.exceptDate) {
    //   timeData.exceptDate = [this.time.exceptions.exceptDate];
    //   if(this.time.exceptions.exceptDate2) {
    //     timeData.exceptDate.push(this.time.exceptions.exceptDate2);
    //   }
    // }

    if(this.time.exceptions.onlyDate && this.time.exceptions.onlyDate.length > 0) {
      console.log('onlyDate');
      timeData.onlyDate = [];
      for(var i = 0; i < this.time.exceptions.onlyDate.length; i++) {
        timeData.onlyDate.push(this.time.exceptions.onlyDate[i]);
      }
    }
    console.log(this.time.exceptions.exceptDate, this.time.exceptions.exceptDate.length);
    if(this.time.exceptions.exceptDate && this.time.exceptions.exceptDate.length > 0) {
      console.log('exceptDate');
      timeData.exceptDate = [];
      for(var j = 0; j < this.time.exceptions.exceptDate.length; j++) {
        timeData.exceptDate.push(this.time.exceptions.exceptDate[j]);
      }
      console.log(timeData.exceptDate);
    }

    console.log(timeData);
    this.schedule.times.push(timeData);
    this.time.exceptions = {
      startDate: null,
      endDate: null,
      exceptDate: [],
      onlyDate: [],
      dailyStarts: null,
      dailyEnds: null,
      andThen: false,
    };
    this.time.gate = '';
  }

  removeTime(line) {
    this.schedule.times.splice(this.schedule.times.indexOf(line), 1);
  }

  removeSpecial(line) {
    this.schedule.special.splice(this.schedule.special.indexOf(line), 1);
  }

  removeElectionTrip(line) {
    this.schedule.electionSchedule.trips.splice(this.schedule.electionSchedule.trips.indexOf(line), 1);
  }


  removeNote(note, type) {
    this.schedule.notes[type].splice(this.schedule.notes[type].indexOf(note), 1);
  }

  removeHoliday(holiday) {
    this.schedule.holidays.splice(this.schedule.holidays.indexOf(holiday), 1);
  }

  saveSchedule(form) {
    this.submitted = true;
    console.log(form);
    console.log(this.schedule.printable);
    if(form.$valid && this.schedule.printable) {
      this.loading = true;
      this._Schedules.save(this.schedule)
          .then(res => {
            this.loading = false;
            console.log('Result', res);
            this._$state.go('schedule.list');
          })
          .catch(err => {
            this.loading = false;
            console.log('Error', err);
            this.errors.saveSchedule = err.data.message;
          });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/schedule/form/form.controller.js